import {
  useWSModal,
  WSActions,
  WSDivider,
  WSForm,
  WSInfoBox,
  WSInputText,
  WSList
} from "@wingspanhq/fe-component-library";
import React from "react";
import * as Yup from "yup";
import { ErrorAlert } from "@components/ErrorAlert";
import { validatorEmail } from "../../../../shared/validators/validatorEmail";
import { useRetargetPayeeEmail } from "../../hooks/useRetargetPayeeEmail";

type FormValues = {
  email: string;
};

type EditEmailModalProps = {
  onClose: () => void;
  email: string;
  payeeId: string;
  onSuccess?: () => void;
};

const EditEmailModal: React.FC<EditEmailModalProps> = props => {
  const [retargetEmail, retargetEmailMeta] = useRetargetPayeeEmail();

  return (
    <WSList gap="L">
      <WSInfoBox>
        Email can only be changed before a contractor signs up. The contractor
        will receive a new invitation at this address.
      </WSInfoBox>
      <WSForm<FormValues>
        defaultValues={{
          email: props.email
        }}
        validationSchema={Yup.object().shape({
          email: validatorEmail.required("Email is required")
        })}
        onSubmit={async formData => {
          await retargetEmail(
            {
              payeeId: props.payeeId,
              targetEmail: formData.email
            },
            {
              onSuccess: () => {
                props.onSuccess?.();
                props.onClose();
              }
            }
          );
        }}
      >
        <WSList gap="M">
          <WSForm.Field
            my="L"
            name="email"
            label="Contractor email"
            description="Contractor’s personal or business email"
            component={WSInputText}
            componentProps={{
              required: true,
              placeholder: "example@example.com",
              type: "email"
            }}
          />
          <ErrorAlert context="Other" error={retargetEmailMeta.error} />

          <WSDivider />

          <WSActions
            alignment="fill"
            buttons={[
              {
                label: "Update email",
                type: "submit",
                kind: "Primary"
              }
            ]}
          />
        </WSList>
      </WSForm>
    </WSList>
  );
};

export function useEditEmailModal() {
  return useWSModal(EditEmailModal, {
    title: "Edit email",
    size: "S"
  });
}
